// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2_BOb","rootCenter":"LoadMoreObserver_rootCenter__1mFNz","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2RcDM"};